import { render, staticRenderFns } from "./BoughtInformation.vue?vue&type=template&id=2371ff4c&"
import script from "./BoughtInformation.vue?vue&type=script&lang=js&"
export * from "./BoughtInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports